


















import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import Order from "@/models/order/Order";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
import {Icon} from "@/helpers/icons";
import OrderUpdateDialogBasicData from "@/components/order/OrderUpdateDialogBasicData.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {OrderUpdateDialogBasicData, AsiCardDetailEntry, AsiCardDetail}
})
export default class OrderCardBasicData extends Vue {

	@Prop({type: Object, required: true})
	public order!: Order;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get isMasterData(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightMasterData);
	}

	@Emit('orderChanged')
	public orderChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

	private formatDateValue(date: string | null): string | null {
		if (date === null) return null;
		return this.$d(new Date(date), 'short');
	}

}
